import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Etasje extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleEtasje = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var etasje = this.props.etasje
        var title = etasje.etasjeplanKode != null ? `${etasje.etasjeplanKode} ${etasje.etasjenummer}` : etasje.etasjenummer

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleEtasje}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{title}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('antallboenheter')}</div>
                            <div className="value">{etasje.antallBoenheter}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealtilbolig')}</div>
                            <div className="value">{etasje.bruksarealTilBolig}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruksarealtilannet')}</div>
                            <div className="value">{etasje.bruksarealtilannet}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksarealtotalt')}</div>
                            <div className="value">{etasje.bruksarealTotalt}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('alternativtareal')}</div>
                            <div className="value">{etasje.alternativtAreal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('alternativtareal2')}</div>
                            <div className="value">{etasje.alternativtAreal2}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealtilbolig')}</div>
                            <div className="value">{etasje.bruttoarealTilBolig}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruttoarealtilannet')}</div>
                            <div className="value">{etasje.bruttoarealTilAnnet}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bruttoarealtotalt')}</div>
                            <div className="value">{etasje.bruttoarealTotalt}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Etasje)